function handleError(event, message, errorSource) {
  const context = {
    error: message,
    stack: errorSource?.stack,
  };

  // Browser plugin errors
  if (
    message?.includes("cashbackReminder") ||
    message?.includes("SCDynimacBridge")
  ) {
    event.preventDefault();
    return;
  }

  // ChunkLoadError handling
  if (
    message?.includes("ChunkLoadError") ||
    message?.includes("Loading chunk") ||
    message?.includes("Loading CSS chunk")
  ) {
    handleChunkError(event, context);
    event.preventDefault();
  }
}

function handleChunkError(event, context) {
  const chunkErrorKey = "last-chunk-error-reload";
  const now = Date.now();
  const lastReload = sessionStorage.getItem(chunkErrorKey);

  // Empêcher de recharger plus d'une fois toutes les 10 secondes pour éviter les boucles infinies
  if (!lastReload || now - parseInt(lastReload) > 10000) {
    const errorType = event.type === "unhandledrejection" ? "promise" : "";
    console.warn(
      `ChunkLoadError ${
        errorType ? `(${errorType}) ` : ""
      }detected, reloading page...`,
      context
    );

    sessionStorage.setItem(chunkErrorKey, now.toString());
    window.location.reload();
  } else {
    console.warn("ChunkLoadError: Reload loop detected. Not reloading.");
  }
}

window.addEventListener("error", (e) => {
  const message = e.error?.message || e.message;
  handleError(e, message, e.error || e.message);
});

window.addEventListener("unhandledrejection", (e) => {
  const message = e.reason?.message;
  handleError(e, message, e.reason);
});
